export const map = [
  {
    path: '/map',
    name: 'Map',
    component: () => import('../views/map/map.vue'),
    meta: {
      hiddenNav: true
    }
  }
];
